import type { Post } from '../types/content'

// Titles match the live blog on immersivestudios.de, word for word.
// Images are stand-ins in the same style until the real thumbnails are added.
const BLOG_BASE = 'https://immersivestudios-83fafce90a550c3da614bf.webflow.io/blog'

export const posts: Post[] = [
  {
    title: 'Modern Website Examples (6 Best Examples for Agencies)',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5632d257-be26-4c9d-a53c-5d01b7167192.jpg',
    href: `${BLOG_BASE}/modern-website-examples-6-best-examples-for-agencies`,
  },
  {
    title: 'Immersive Website Pros and Cons: Is it the Right Move?',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e47b82ca-c93b-4256-981f-c2ee7c0a9f55.jpg',
    href: BLOG_BASE,
  },
  {
    title: 'Industries That Benefit From 3D Websites',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0470caef-9147-47fc-93d0-981cf16421fc.jpg',
    href: BLOG_BASE,
  },
  {
    title: 'What is a 3D Website? [Complete Guide 2024]',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/976ed178-385d-436e-8325-7fd99ebebd1a.jpg',
    href: BLOG_BASE,
  },
  {
    title: 'Websites: 11 Serious Untruths resolved that will change your perspective completely!',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1d6890f3-e7ab-4c1c-8f28-2feec84ecef9.jpg',
    href: BLOG_BASE,
  },
  {
    title: 'The basics of a Scrollytelling website',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/463c38c4-b30d-4193-9443-aea0d960a1d6.jpg',
    href: BLOG_BASE,
  },
]
